import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { SuperAdminDowngradeResponse, SuperAdminUser, SuperAdminUserUpgrade } from 'src/types/shared/SuperAdminUser';

export const downgradeSuperAdminUserRequest = createAction('downgradeSuperAdminUserRequest');
export const downgradeSuperAdminUserSuccess = createAction<SuperAdminUser>(
    'downgradeSuperAdminUserSuccess',
);
export const downgradeSuperAdminUserFailure = createAction('downgradeSuperAdminUserFailure');

export const downgradeSuperAdminUser = (id: number, postBody: SuperAdminUserUpgrade) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(downgradeSuperAdminUserRequest());
    try {
        const { data }: UpdateAdminResponse = await api.post(
            `admin/superadmins/${id}/downgrade`,
            postBody,
        );

        dispatch(downgradeSuperAdminUserSuccess(data.user));
    } catch (e) {
        handleApiErrors(dispatch, downgradeSuperAdminUserFailure, e);
    }
};

interface UpdateAdminResponse {
    data: SuperAdminDowngradeResponse;
}
